import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  loadCertificates () {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/certificates/').then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  updateCertificate (certificate) {
    return new Promise((resolve, reject) => {
      let formData = new FormData()

      if (typeof certificate.file !== 'string') {
        formData.append('file', certificate.file)
      }
      formData.append('title', certificate.title)
      formData.append('issued_at', certificate.issued_at)
      formData.append('expires_at', certificate.expires_at)
      formData.append('location', certificate.location)

      axiosInstance.patch(`/certificates/${certificate.id}/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  createCertificate (certificate) {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('file', certificate.file)
      formData.append('title', certificate.title)
      formData.append('issued_at', certificate.issued_at)
      formData.append('expires_at', certificate.expires_at)
      formData.append('location', certificate.location)

      axiosInstance.post('/certificates/', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
